export default {
  translation: {
    'form.validation.required': 'กรอก {{field_name}} ให้ครบถ้วน',
    'form.validation.maxlength': '{{field_name}} ยาวเกินไป',
    'form.validation.minlength': '{{field_name}} สั้นเกินไป',
    'form.validation.invalid': '{{field_name}} ไม่ถูกต้อง',
    'form.validation.unique': '{{field_name}} ถูกใช้ไปแล้ว โปรดเลือกอีกครั้ง',
    'membership.profile.optional_field': '(ไม่จำเป็น)',
    'dropdown.hint': 'โปรดเลือก',

    'member_points.unit': 'คะแนน',
    'member_points.point_balance': 'คะแนนคงเหลือ',
    'member_points.point_history': 'ประวัติการใช้คะแนน',
    'member_points.fields.date': 'วันที่',
    'member_points.rule': 'กฎคะแนนสมาชิก',
    'member_points.display.expire_point': 'คะแนนที่กำลังจะหมดอายุ',
    'member_points.display.successive_expire_point':
      'คะแนนหลังจากนั้นจะหมดอายุ',
    'member_points.fields.expire': 'หมดอายุ',
    'member_points.fields.successive_expire': 'หลังจากนั้นจะหมดอายุ',
    'member_points.fields.remarks': 'จุดเปลี่ยนเหตุผล',
    'member_points.fields.value': 'สถานะคะแนน',
    'member_points.fields.expiry_date': 'วันหมดอายุ',
    'member_points.fields.member_point_expired': 'คะแนนหมดอายุ',
    'member_points.fields.auto_reward': 'คะแนนที่ได้รับรางวัลจากการสั่งซื้อ',
    'member_points.fields.auto_reward_seconds': 'รับคะแนน',
    'member_points.no_data': 'ไม่มีบันทึกคะแนน',
    'member_points.redeem_cash_description':
      'ทุก {{costPoint}} คะแนน ลด {{discountMoney}}',
    'member_points.fields.revert_member_point':
      'คะแนนถูกแลกคืนจากออเดอร์ที่ยกเลิก',
    'member_points.equal_cash': 'เท่ากับ {{money}}',
    'member_points.title': 'คะแนนสมาชิก',
    'member_points.fields.expired': 'คะแนนหมดอายุแล้ว',

    'member_points.fields.product_review_reward':
      'ตรวจสอบคำสั่งซื้อ <a></a> แล้ว',
    'member_points.fields.revert_member_point.order_edit':
      'คืนคะแนนจากคำสั่งซื้อที่ถูกแก้ไข',
    'member_points.fields.revert_member_point.return_order_revert':
      'คะแนนที่ให้คืน; จากการคืนคำสั่งซื้อ',
    'member_points.fields.revert_member_point.order':
      'Reverted points; from order',
    'member_points.fields.member_info_reward':
      'คะแนนสมาชิกเมื่อตั้งค่าข้อมูลสมาชิกเสร็จสมบูรณ์',
    'store_credits.fields.display.never_expired': 'ไม่มีวันหมดอายุ',
    'member_points.fields.order_redeemed': 'ใช้คะแนนแลกเป็นของขวัญในคำสั่งซื้อ',
    'member_points.fields.redeemed_to_cash':
      'ใช้คะแนนแลกเป็นส่วนลดในคำสั่งซื้อ',
    'member.center.load.more': 'เพิ่มเติม',
    'store_credits.fields.never_expires_point': 'คะแนนไม่มีวันหมดอายุ',
    'member_points.display.redeem_btn': 'แลกรับของขวัญ',
    'promotions.page.term.confirm': 'ยืนยัน',

    'store_credits.title': 'เครดิตร้านค้า',
    'store_credits.credit_balance': 'เครดิตคงเหลือ',
    'store_credits.credit_history': 'ประวัติเครดิต',
    'store_credits.fields.date': 'วันที่',
    'store_credits.fields.remarks': 'เหตุผลในการเปลี่ยนเครดิต',
    'store_credits.fields.value': 'สถานะเครดิต',
    'store_credits.fields.expiry_date': 'วันหมดอายุ',
    'store_credits.fields.balance': 'เครดิตคงเหลือ',
    'store_credits.fields.order_prefix': 'ใช้เครดิตในออเดอร์',
    'store_credits.fields.welcome_credit': 'เครดิตต้อนรับ',
    'store_credits.fields.member_info_quick_completion_credit':
      'เครดิตรางวัลเมื่อตั้งค่าข้อมูลสมาชิกเสร็จสมบูรณ์',
    'store_credits.fields.birthday_credit': 'เครดิตวันเกิด',
    'store_credits.fields.user_credit_expired': 'เครดิตหมดอายุ',
    'store_credits.fields.never_expires': 'ไม่มีวันหมดอายุ',
    'store_credits.fields.auto_reward_prefix': 'Order ',
    'store_credits.fields.auto_reward': ' gets reward credits',
    'store_credits.fields.revert_credit': 'เครดิตคืนกลับจากออเดอร์ที่ถูกยกเลิก',
    'store_credits.fields.revert_credit.return':
      'เรียกคืนเครดิตจากคำสั่งซื้อที่ส่งคืน',
    'store_credits.fields.revert_credit.order_split':
      'Credits reverted from split order',
    'store_credits.fields.revert_credit.order_edit':
      'คืนเครดิตจากคำสั่งซื้อที่ถูกแก้ไข',
    'store_credits.fields.revert_credit.order': 'Reverted credits; from order',
    'store_credits.fields.revert_credit.return_order_revert':
      'เครดิตที่ให้คืน; จากการคืนคำสั่งซื้อ',
    'store_credits.fields.product_review_reward':
      'ตรวจสอบคำสั่งซื้อ <a></a> แล้ว',
    'store_credits.no_data': 'ไม่มีบันทึกเครดิต',

    'member_point.list.empty.description': 'ซื้อตอนนี้เพื่อรับคะแนนเพิ่ม!',
    'store_credits.list.empty.description': 'ซื้อตอนนี้เพื่อรับเครดิตเพิ่ม!',
    'member_center.list.empty.buttonText': 'ช้อปเลย!',
    // Member Profile
    'member_profile.member_info.title':
      'รางวัลการตั้งค่าข้อมูลสมาชิกเสร็จสมบูรณ์',
    'member_profile.member_info.hint':
      'กรอกข้อมูลสมาชิกดังต่อไปนี้: {{fields}} คุณจะได้รับ {{rewards}} หลังจากกรอกข้อมูลสมาชิกเรียบร้อยแล้ว',
    'member_profile.member_info.sent':
      'หลังจากการตรวจสอบข้อมูลเสร็จสิ้น โบนัสการกรอกประวัติสมาชิกจะออกให้!',
    'member_profile.member_referral.discount': 'แคมเปญแนะนำสมาชิก',
    'member_profile.member_referral.rules': 'กฎเกณฑ์ของแคมเปญ',
    'member_profile.member_referral.code.copy_and_share':
      'แชร์ลิงค์ให้กับเพื่อนของคุณ เพื่อรับเครดิตร้านค้า.',
    'member_profile.member_referral.code.remarks': 'กฎเกณฑ์ของแคมเปญ',
    'member_profile.member_referral.generate.success': 'สร้างลิงค์อ้างอิงแล้ว',
    'member_profile.member_referral.copy': 'คัดลอกลิงค์',
    'member_profile.member_referral.copy.success': 'ลิงค์คัดลอกเรียบร้อยแล้ว',
    'membership.profile.email': 'อีเมล',
    'membership.profile.verification_hint':
      'หากคุณเปลี่ยนที่อยู่อีเมลจำเป็นต้องมีการยืนยันหลังจากบันทึก อีเมลจะอัปเดตเป็น {{unconfirmedEmail}} หลังจากการยืนยันเสร็จสิ้น',
    'membership.profile.verified_success': 'ตรวจสอบแล้ว',
    'membership.profile.not_verified_yet': 'ยังไม่ได้รับการตรวจสอบ',
    'membership.profile.send_verification_email': 'ส่งอีเมลล์ยืนยัน',
    'users.save.email_verification.success':
      'บันทึกการเปลี่ยนแปลงของคุณแล้ว ที่อยู่อีเมลจะได้รับการอัปเดตหลังจากการยืนยันตัวตนเสร็จสมบูรณ์',
    'users.save.email_verification.send': 'อีเมลยืนยันถูกส่งเรียบร้อยแล้ว',
    'user.sign_up.email_verification.dialog.title':
      'ส่งอีเมลยืนยันไปที่ {{email}} เรียบร้อยแล้ว',
    'user.sign_up.email_verification.dialog.description':
      'โปรดยืนยันอีเมลตอนนี้และที่อยู่อีเมลใหม่จะได้รับการอัปเดต หากคุณไม่ได้รับ โปรดใส่อีเมลของคุณอีกครั้งและบันทึก',
    'user.sign_up.email_verification.dialog.confirm': 'ยืนยัน',

    'users.membership.member_info.title':
      'รางวัลการตั้งค่าข้อมูลสมาชิกเสร็จสมบูรณ์',
    'users.membership.member_info.hint':
      'กรอกข้อมูลสมาชิกดังต่อไปนี้: {{fields}} คุณจะได้รับ {{rewards}} หลังจากกรอกข้อมูลสมาชิกเรียบร้อยแล้ว',
    'users.membership.member_info.sent':
      'หลังจากการตรวจสอบข้อมูลเสร็จสิ้น โบนัสการกรอกประวัติสมาชิกจะออกให้!',
    'users.membership.member_info.symbol': ', ',
    'users.membership.member_info.name': 'ช่ือ',
    'users.membership.member_info.email': 'อีเมล',
    'users.membership.member_info.mobile': 'หมายเลขโทรศัพท์',
    'users.membership.member_info.gender': 'เพศ',
    'users.membership.member_info.gender.male': 'ชาย',
    'users.membership.member_info.gender.female': 'หญิง',
    'users.membership.member_info.gender.other': 'ไม่เปิดเผย',
    'users.membership.member_info.birthday': 'วันเกิด',
    'users.membership.member_info.password': 'รหัสผ่าน',
    'users.membership.member_info.password.change': 'ตั้งรหัสผ่านใหม่',
    'users.membership.member_info.account_binding': 'บัญชีบุคคลที่สาม',
    'users.membership.member_info.user_credits':
      'เครดิตร้านค้า {{count}} คะแนน',
    'users.membership.member_info.member_points': 'คะแนนสมาชิก {{count}} คะแนน',
    'users.membership.member_info.coupons': 'คูปอง {{count}} ใบ',
    'users.membership.expiry_date': 'วันหมดอายุสมาชิก',
    'users.membership.offer.discount': 'ข้อเสนอสำหรับสมาชิก',
    'users.membership.upgrade.next_tier': 'อัปเกรดเป็น {{tier_name}}',
    'users.membership.upgrade.next_tier.discount': ', รับส่วนลด {{discount}}%',
    'users.membership.spending_within_months':
      'อัปเกรดด้วยยอดซื้อรวมทั้งหมดมากกว่า {{spending}} ภายใน {{months}} เดือน',
    'users.membership.spending_single_purchase':
      'อัปเกรดด้วยยอดซื้อครั้งเดียวมากกว่า {{spending}}',
    'users.membership.extension.condition': 'เงื่อนไขการต่ออายุสมาชิก',
    'users.membership.extension.status': 'Membership Extend Status',
    'users.membership.extend_valid_period':
      '{{type}} มากกว่า {{spending}} ในระยะเวลาที่เป็นสมาชิก ภายใน {{months}} เดือน',
    'users.membership.within_interval': 'ยอดซื้อรวมทั้งหมด',
    'users.membership.single_purchase': 'ยอดซื้อครั้งเดียว',
    'users.membership.all_tiers': 'ดูรายการระดับสมาชิกทั้งหมด',
    'users.membership.tier.extend': 'Eligible to extend {{tier}}?',
    'users.membership.tier.upgrade.to_next_level.single':
      'อัปเกรดไปยังระดับสมาชิกขั้นถัดไป?',
    'users.membership.tier.upgrade.condition.continue': 'เลือกซื้อสินค้าต่อ',
    'users.membership.tier.upgrade.completed': 'สามารถอัพเกรดได้',
    'users.membership.tier.expire.date.description':
      'การอัปเกรดระดับสมาชิกจะถูกตรวจสอบตอนเที่ยงคืน สมาชิกจะไม่ถูกอัปเกรดระดับสมาชิกหากคำสั่งซื้อถูกยกเลิก/คืนเงิน',
    'users.membership.tier.expire.date.auto_downgrade.description':
      'การอัปเกรดระดับสมาชิกจะถูกตรวจสอบตอนเที่ยงคืน สมาชิกจะไม่ถูกอัปเกรดระดับสมาชิกหากคำสั่งซื้อถูกยกเลิก/คืนเงิน',
    'users.membership.tier.extension.date.description':
      'Membership extension will not be effective if order has been cancelled/refunded.',
    'users.membership.all_tiers.description':
      'หากไม่มีการต่ออายุสมาชิกจะถูกลดระดับเมื่อถึงวันหมดอายุสมาชิก',
    'users.membership.tier.upgrade.condition': 'เงื่อนไขอัปเกรดระดับสมาชิก:',
    'users.membership.tier.upgrade.condition.dollar':
      'ปัจจุบันยังไม่มียอดซื้อครั้งเดียวมากกว่า {{dollar}}',
    'users.membership.tier.expire.date': 'ระยะเวลาสมาชิก:',
    'users.membership.tier.shopping_discount':
      'สมาชิกได้รับส่วนลด {{discount}}%',
    'users.membership.tier.extend.condition': 'เงื่อนไขต่ออายุสมาชิก:',
    'users.membership.tier.extend.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within {{month}}-month membership valid period. Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within membership valid period. Congrats! Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.within_interval':
      'Your total purchase within {{month}}-month membership valid period is {{spending}}. {{dollar}} more to extend.',
    'users.membership.tier.extend.within_interval.can_extend':
      'Your total purchase within {{month}}-month membership valid period is over {{dollar}}. Extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.within_interval':
      '{{dollar}} more to extend',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      'Congrats! Extension will be effective on expiry date.',
    'users.member.normal-level': 'ทั่วไป',
    'users.membership.max_level_tier':
      'ยินดีด้วย! คุณอยู่ในระดับสมาชิกสูงสุดแล้ว',
    'users.membership.tier.discount_percentage.caption': 'ลด {{ value }}%',

    'membership.profile.birthday': 'วันเกิด',
    'birthday_picker.year.placeholder': 'Year',
    'birthday_picker.month.placeholder': 'Month',
    'birthday_picker.date.placeholder': 'Date',
    'form.validation.birthday.required': 'Birthday is required',
    'form.validation.birthday.invalid': 'Birthday is invalid',
    'form.validation.birthday.invalid.minimum_age_limit':
      'Birthday is invalid, should over {{minimumAgeLimit}} years old.',
    'users.birthday.faq':
      'You should over certain age to register and shop at the online store.',
    'membership.edit.send_me_check_mode': 'ส่งรหัสยืนยันให้ฉัน',
    'membership.edit.select_saved_mobile_number': 'เลือกมเบอร์ติดต่อนทึกไว้',
    'session.mobile_signup.check_mobile.title':
      'โปรดตรวจสอบหมายเลขโทรศัพท์มือถือว่าถูกต้องดังนี้ ข้อความสั้นกำลังส่งไปที่หมายเลขโทรศัพท์มือถือนี้',
    'session.mobile_signup.check_mobile.your_number':
      'หมายเลขโทรศัพท์มือถือของคุณ',
    'session.mobile_signup.check_mobile.send_code': 'ส่งรหัสตรวจสอบมาให้ฉัน',
    'session.mobile_signup.check_mobile.go_back.1': 'คุณสามารถ',
    'session.mobile_signup.check_mobile.go_back.2': 'ย้อนกลับไป',
    'session.mobile_signup.check_mobile.go_back.3':
      'เพื่อแก้ไขหมายเลขโทรศัพท์มือถือหากผิดพลาด',
    'session.mobile_signup.input_code.hint': 'โปรดระบุรหัสตรวจสอบที่คุณได้รับ',
    'session.mobile_signup.input_code.submit': 'ไป',
    'session.mobile_signup.input_code.resend.countdown':
      'ส่งข้อความรหัสตรวจสอบอีกครั้งมาที่โทรศัพท์ของฉัน ({{resendCountdown}} sec)',
    'session.mobile_signup.input_code.resend':
      'ส่งข้อความรหัสตรวจสอบอีกครั้งมาที่โทรศัพท์ของฉัน',
    'session.forget_passowrd.check_phone.error':
      'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง โปรดตรวจสอบอีกครั้ง',
    'session.mobile_center.check_phone.error':
      'หมายเลขโทรศัพท์มือถือถูกใช้ไปแล้ว',
    'user.sign_up.check_phone.error':
      'This is same as current mobile phone.<br>Please change another phone if you want to update it.',
    'membership.profile.mobile.number.verified':
      'การยืนยันหมายเลขโทรศัพท์เสร็จเรียบร้อย และจะแทนที่หมายเลขโทรศัพท์ที่คุณบันทึกไว้ก่อนหน้านี้',
    'membership.profile.delivery_addresses': 'บันทึกที่อยู่ในการจัดส่งสินค้า',
    'users.add.delivery_address.maximum':
      'คุณสามารถเพิ่มที่อยู่ได้สูงสุด 5 รายการ',
    'users.add.delivery_address': 'เพิ่มที่อยู่ใหม่',
    'checkout.address.recipient': 'ชื่อผู้รับ',
    'checkout.address.recipient_phone': 'หมายเลขโทรศัพท์ผู้รับ',
    'member_profile.line.subscribe.error.already_in_used':
      'บัญชี LINE นี้ถูกใช้งานโดยสมาชิกท่านอื่นแล้ว กรุณาติดต่อร้านค้าเพื่อขอความช่วยเหลือ',
    'member_profile.subscribe': 'สมัครรับการแจ้งเตือน',
    'member_profile.subscribed': 'ติดตามแล้ว',
    'member_profile.notification.promotion': 'แจ้งเตือนโปรโมชัน',
    'member_profile.notification.order': 'แจ้งเตือนคำสั่งซื้อ',
    'member_profile.subscribe.successfully': 'สมัครสำเร็จ',
    'member_profile.subscribe.error': 'การสมัครล้มเหลว กรุณาติดต่อร้านค้า',
    'member_profile.line.subscribe.error.already_for_registration':
      'สมัครล้มเหลว บัญชี LINE นี้ถูกใช้สมัครแล้วโดยสมาชิกท่านอื่น กรุณาลงชื่อเข้าสู่ระบบด้วยบัญชี LINE และลองอีกครั้ง',
    'member_profile.line.subscribe.error.different_id':
      'Failed to subscribe. Please log in with the LINE account of the member account.',
    'member_profile.line.subscribe.error':
      'การสมัครล้มเหลว กรุณาเข้าสู่ระบบ LINE อีกครั้ง',
    'member_profile.facebook.subscribe.error':
      'การสมัครล้มเหลว กรุณาเข้าสู่ระบบ Facebook อีกครั้ง',
    'member_profile.social.subscribe.error.already_bound_to':
      'สมัครล้มเหลว บัญชีโซเชียลนี้ถูกผูกกับสมาชิกท่านอื่นแล้ว กรุณาติดต่อร้านค้าเพื่อยกเลิกการผูก',
    'member_profile.email.subscribe.error':
      'การสมัครล้มเหลว กรุณากรอกอีเมลและลองอีกครั้ง',
    'member_profile.sms.subscribe.error':
      'การสมัครล้มเหลว กรุณากรอกหมายเลขโทรศัพท์และลองอีกครั้ง',
    'member_profile.unsubscribe.successfully': 'ถอนการสมัครสำเร็จ',
    'member_profile.unsubscribe.error':
      'ไม่สามารถยกเลิกการสมัครได้ โปรดลองอีกครั้งในภายหลัง',
    'member_profile.error.unknown': 'อุ๊ย! มีข้อผิดพลาดเกิดขึ้น',
    'member_profile.error.refresh': 'กรุณารีเฟรชหน้าเพจหรือลองอีกครั้งภายหลัง',
    'member_profile.retry': 'Try again',
    'member_profile.profile': 'โปรไฟล์',
    'member_profile.subscription': 'สมัครรับการแจ้งเตือน',
    'member_profile.delivery_payment': 'ข้อมูลการจัดส่งและชำระเงิน',
    'member_profile.phone': 'Contact Phone',
    'users.invoice_carrier': '發票載具',
    'users.electronic_invoice_carrier':
      'สรุปใบแจ้งหนี้อิเล็กทรอนิกส์ในบัญชีของคุณ',
    'member_profile.confirm': 'บันทึกการเปลี่ยนแปลง',
    'member_profile.cancel': 'ยกเลิก',
    'users.save.success': 'บันทึกการเปลี่ยนแปลงของคุณแล้ว',
    'users.error.not_save_mobile_phone':
      'โปรดยืนยันหมายเลขโทรศัพท์นี้ก่อนบันทึกการเปลี่ยนแปลง',
    'verification.email.trial_merchant.reach_limit.failure':
      'ไม่สามารถส่งอีเมลยืนยันได้ระหว่างการทดลองใช้งานของร้านค้า หากต้องการใช้งาน โปรดติดต่อร้านค้าเพื่อขอความช่วยเหลือ ขอบคุณ',
  },
};
